import * as firebaseMain from 'firebase/app';
import firestore from 'firebase/app';
import { toastr } from 'react-redux-toastr';
import { reset, SubmissionError } from 'redux-form';
import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from '../../common/async/asyncActionStart';
import { closeModal } from '../../common/modals/modalActions.js';
import {
  updateLastLogin,
  updateProfile,
} from '../Dashboard/UpdateProfile/profileActions';

const { serverTimestamp } = firestore.firestore.FieldValue;

export const loginUser = (credentials, history) => {
  return async (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();

    if(!credentials.email || !credentials.password){
      throw new SubmissionError({_error : "Email and Password should not be empty!"})
    }

    try {
      dispatch(asyncActionStart());
      const user = await firebase
        .auth()
        .signInWithEmailAndPassword(credentials.email, credentials.password);

      let newUser = {
        uid: user.user.uid,
        lastSignIn: serverTimestamp(),
      };
      dispatch(updateLastLogin(newUser));
      dispatch(asyncActionFinish());

      toastr.success('Login Success', 'You are logged in.');
    } catch (error) {
      console.error(error);
      if (error) {
        dispatch(asyncActionError());
        toastr.error('Login Error', 'You are not logged in.');
        throw new SubmissionError({ _error: error.message });
      }
    }
  };
};

export const registerUser = (user, history) => async (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const firestore = getFirestore();

  try {
    let createdUser = await firebase
      .auth()
      .createUserWithEmailAndPassword(user.email, user.password);
    //console.log(createdUser);
    await createdUser.user.updateProfile({
      displayName: user.displayName,
    });
    let newUser = {
      displayName: user.displayName,
      createdAt: serverTimestamp(),
      role: 'complainant',
      email: user.email,
      isNewUser: true,
      profileIsEmpty: true,
      uid: createdUser.user.uid,
    };

    await firestore.set(`users/${createdUser.user.uid}`, { ...newUser });
  } catch (error) {
    console.error(error);
    throw new SubmissionError({ _error: error.message });
  }
};

export const socialLogin = (selectedProvider) => async (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const firestore = getFirestore();

  try {
    dispatch(asyncActionStart());
    const user = await firebase.login({
      provider: selectedProvider,
      type: 'popup',
    });

    let newUser = {
      lastSignIn: serverTimestamp(),
    };

    console.log('NEW USER', user.profile);

    if (user.additionalUserInfo.isNewUser) {
      const newUser = {
        displayName: user.profile.displayName,
        photoURL: user.profile.avatarUrl,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        role: 'complainant',
        email: user.profile.email,
        isNewUser: true,
        profileIsEmpty: true,
        uid: user.user.uid,
      };
      dispatch(updateProfile(newUser));
    } else {
      dispatch(updateLastLogin(newUser));
    }

    dispatch(asyncActionFinish());
    toastr.success('Login Success', 'You are logged in.');
  } catch (error) {
    dispatch(asyncActionError());
    //console.log(error);
    toastr.error('Login failed', 'You are logged in. ' + error.message);
  }
};

export const updatePassword = (credentials) => async (
  dispatch,
  getState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const user = firebase.auth().currentUser();

  try {
    await user.updatePassword(credentials.newPassword1);
    await dispatch(reset('account'));
  } catch (error) {
    console.error(error);
  }
};

export const sendForgotPasswordEmail = (email) => async (
  dispatch,
  getState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  //console.log(email.email);

  try {
    await firebase
      .auth()
      .sendPasswordResetEmail(email.email)
      .then((data) => {
        //console.log(data);
        dispatch(closeModal());
        toastr.success(
          'Success',
          'Please check your email for the password reset link'
        );
      });
  } catch (error) {
    console.error(error);
    toastr.error('Failed', 'Password reset failed. ' + error.message);
  }
};
